import { ListItem, withStyles } from '@material-ui/core';

/**
 * Styled components for the BaseDropdown component
 */

// Styling constants
const COLORS = {
  hover: '#f6f6f6',
  selected: 'rgb(235, 245, 255)',
  disabled: '#f5f5f5',
  disabledText: '#ccc'
} as const;

const DIMENSIONS = {
  padding: '8px 12px',
  borderRadius: '12px',
  minHeight: '40px'
} as const;

export const StyledListItem = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: DIMENSIONS.padding,
    borderRadius: DIMENSIONS.borderRadius,
    minHeight: DIMENSIONS.minHeight,
    transition: 'background-color 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: COLORS.hover
    },
    '&:focus': {
      backgroundColor: COLORS.hover,
      outline: 'none'
    },
    '&.selected': {
      backgroundColor: COLORS.selected
    },
    '&.selected:hover': {
      backgroundColor: COLORS.selected
    },
    '&.disabled': {
      backgroundColor: COLORS.disabled,
      color: COLORS.disabledText,
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: COLORS.disabled
      }
    }
  }
})(ListItem);
